import React from 'react';

import { Link as RouterLink } from '~/lib/react-router-dom';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, IconButton, Tooltip } from '@mui/material';

type Props = {
  orderId?: string | number | null;
};

export default function OrderIdLinkCompressed({ orderId }: Props) {
  const orderIdValue = String(orderId ?? '').trim();
  if (!orderIdValue) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', minWidth: 0 }}>
      <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}>
        {orderIdValue}
      </Box>
      <Tooltip title="Open order">
        <IconButton
          component={RouterLink}
          to={`/purchases/${orderIdValue}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          size="small"
          sx={{ p: 0.25, ml: 0.5, flexShrink: 0 }}
        >
          <OpenInNewIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
